import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
//primeReact
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
//components
import NumberInput from "../../../../../../components/input/NumberInput";
import CalendarInput from "../../../../../../components/input/CalendarInput";
//imports
import Select from "../../../../../../components/input/Select";
import TextareaInput from "../../../../../../components/input/TextareaInput";
import { createParcel } from "../../../../../../services/Parcel/createParcel";
import { useParcelContext } from "./ParcelContext";

const ModalCreateInstallments = () => {
  const {
    control,
    handleSubmit: handleCreateParcel,
    reset: resetCreateParcel,
    errors,
  } = useForm();

  const {
    idSale,
    parcelsDescription,
    setItemsSelected,
    setSelectAll,
    isModalVisibleAddParcel,
    setIsModalVisibleAddParcel,
    setSelectedValue,
    refetch,
  } = useParcelContext();

  // Função para formatar data no formato 'yyyy-MM-dd'
  const formatToBackendDate = (date) => {
    if (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    } else {
      return ""; // Retorna uma string vazia se o campo estiver vazio
    }
  };

  const style = {
    width: window.innerWidth <= 992 ? "95vw" : "95vw",
  };

  function sendCreate(data) {
    let obj = [];
    obj = {
      value: data.add_value,
      amount: data.amount,
      due_data: data.due_data,
      installment_description_id: data.installment_description_id,
      obs: data.instruction_client,
      sale_id: idSale,
    };
    setIsModalVisibleAddParcel(false);

    const notification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );

    // Executa a função de atualização das parcelas
    createParcel(obj)
      .then(() => {
        // Em seguida, atualiza os itens selecionados e chama a função de refresh
        setItemsSelected([]);
        setSelectAll([]);
        resetCreateParcel();
        return refetch();
      })
      .then(() => {
        // Depois que o refresh for concluído com sucesso, atualize a notificação para indicar sucesso
        toast.update(notification, {
          render: "Parcelas adicionadas com sucesso!",
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
      })
      .catch((error) => {
        toast.update(notification, {
          render: "Não foi possível adicionar as parcelas!",
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
        console.error("Erro ao atualizar parcelas:", error);
      });
  }

  return (
    <>
      <Dialog
        header="Adicionar Parcelas"
        id="modal_cad"
        className="rounded-4"
        visible={isModalVisibleAddParcel}
        onHide={() => setIsModalVisibleAddParcel(!isModalVisibleAddParcel)}
        style={style}
      >
        <Divider align="left">
          <div className="inline-flex align-items-center">
            <i className="pi pi-user mr-2"></i>
            <b> Informações das parcelas</b>
          </div>
        </Divider>
        <form onSubmit={handleCreateParcel(sendCreate)}>
          <div>
            <div className="mb-2 row justify-content-between">
              <div className="col-md-6 my-2">
                <NumberInput
                  onChange={(e) => {
                    setSelectedValue((prevValue) => ({
                      ...prevValue,
                      add_value: e.value,
                    }));
                  }}
                  suffix={""}
                  mode="currency"
                  currency="BRL"
                  locale="pt-BR"
                  useGrouping={true}
                  placeholder={"0"}
                  max={undefined}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  name="add_value"
                  control={control}
                  label="Valor da Parcela"
                  required={true}
                />
              </div>
              <div className="col-md-6 my-2">
                <NumberInput
                  onChange={(e) => {
                    setSelectedValue((prevValue) => ({
                      ...prevValue,
                      add_amount: e.value,
                    }));
                  }}
                  max={400}
                  type="textarea"
                  className="p-inputtext-sm rounded-4"
                  label="Quantidade de Parcelas"
                  errors={errors}
                  required={true}
                  control={control}
                  name="amount"
                />
              </div>
              <div className="col-md-6 my-2">
                <CalendarInput
                  onChange={(e) => {
                    setSelectedValue((prevValue) => ({
                      ...prevValue,
                      add_due_data: formatToBackendDate(e.value),
                    }));
                  }}
                  type="textarea"
                  className="p-inputtext-sm rounded-4"
                  label="Data de Vencimento"
                  errors={errors}
                  isRequired={true}
                  control={control}
                  name="due_data"
                  rows={4}
                  cols={30}
                />
              </div>
              <div className="col-md-6 my-2">
                <Select
                  onChange={(e) => {
                    setSelectedValue((prevValue) => ({
                      ...prevValue,
                      add_installment_description_id: e ? e : null,
                    }));
                  }}
                  className="p-inputtext-sm rounded-4"
                  optionLabel="description"
                  label="Descrição"
                  isRequired={true}
                  optionValue="id"
                  control={control}
                  options={parcelsDescription || []}
                  name="installment_description_id"
                />
              </div>
            </div>
            <TextareaInput
              onChange={(e) => {
                setSelectedValue((prevValue) => ({
                  ...prevValue,
                  add_obs: e.target.value,
                }));
              }}
              type="textarea"
              className="p-inputtext-sm rounded-4"
              label="Observação"
              errors={errors}
              isRequired={true}
              control={control}
              name="instruction_client"
              rows={4}
              cols={30}
            />
            <div className="text-center mt-3">
              <Button
                rounded
                label="Adicionar"
                icon="fa fa-plus"
                type="submit"
                className="p-inputtext-sm m-auto"
              />
            </div>
          </div>
        </form>
      </Dialog>
    </>
  );
};

export default ModalCreateInstallments;
